import * as React from 'react';
import ApEditorMode from '../enums/ApEditorMode';
import { ApActionBase } from '../sic-lib/types/ActionPlan';
import { ApPlanAction } from '../sic-lib/types/ApPlanAction';
import { ApTemplateAction } from '../sic-lib/types/ApTemplateAction';

export default function useActionMessageDataMapper(
    editMode: ApEditorMode,
    action: ApActionBase,
): {
    subject: string;
    body: string;
} {
    const [messageData, setMessageData] = React.useState<{
        subject: string;
        body: string;
    }>({
        subject: '',
        body: '',
    });

    React.useEffect(() => {
        const mappedData =
            editMode === ApEditorMode.template
                ? {
                      subject: (action as ApTemplateAction).subject,
                      body: (action as ApTemplateAction).body,
                  }
                : {
                      subject: (action as ApPlanAction).data.subject || '',
                      body: (action as ApPlanAction).data.body || '',
                  };

        setMessageData(mappedData);
    }, [action, editMode]);

    return messageData;
}
